<template>
        <div class="loadingBalls">
            <div v-for="(ball, index) in ballColor" :key="index" 
            class="ball"
            :class="toggleAnimation?'':'bounceAnimationClass'"
            :style="{background:ball,animationDelay:(0.2*index)+'s'}"
            ></div>

        </div>
</template>

<script>

export default {
    name: "loadingBalls",
    components: {

    },
    props: {
        ballColor: {
            type: Array,
            default: ()=>[
            '#4285F5',
            '#EA4436',
            '#FBBD06',
            '#34A952'
            ]
        },
    },
    data() {
        return {
            toggleAnimation: false,
        }
    },
    mounted(){

    },
    methods: {

    },
    computed:{

    },
    beforeDestroy() {

    },
};
</script>
  
<style lang="scss" scoped>
  
   .loadingBalls {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 40px;
      gap: 8px;
  }
  
  .ball {
    width: 10px;
    height: 10px;
    border-radius: 11px;
}
.bounceAnimationClass{
    //transform: translateY(-5px);
    animation: 2s bounce ease infinite;
    
  }
.swellAnimationClass{
    transform: scale(.6);
    animation: 2s swell ease infinite;
  }
  
  .blue {
    background-color: #4285F5;
  }
  
  .red {
    background-color: #EA4436;
    animation-delay: .25s;
  }
  
  .yellow {
    background-color: #FBBD06;
    animation-delay: .5s;
  }
  
  .green {
    background-color: #34A952;
    animation-delay: .75s;
  }
  
  @keyframes bounce {  
      10% {
          transform: translateY(-0px);
      }
      30% {
          transform: translateY(-5px);
      }
      80% {
          transform: translateY(0px);
      }
  }
//   @keyframes bounce {  
//       50% {
//           transform: translateY(5px);
//       }
//   }
  @keyframes swell {  
      50% {
          transform: scale(.9);
      }
  }
    </style>